import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

import authReducer, { user, auth } from './slices/authSlice';
import loadReducer, { load } from './slices/loadSlice';
import dialogReducer, { dialog } from './slices/dialogSlice';
import themeReducer, { theme } from './slices/themeSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    load: loadReducer,
    dialog: dialogReducer,
    theme: themeReducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default {
  dialog,
  load,
  user,
  auth,
  theme,
};
